<template>
	<div>
		<firstsceenimage :imgobj='banner' title="把握流行，精准选款" subtitle="用AI大数据的力量帮助决策者精准定位" button="white"
			stylemode="white">
			<a href="https://mp.weixin.qq.com/s/rAf24d_fOowbaTu9_HQBww">
				<button
					style=" font-size: 13px; border: 1px solid #E8C570;color: black; margin-top: 25px;line-height: 32px;  width: 80px; height: 32px;background-color: #E8C570;">
					预约演示
				</button>
			</a>
		</firstsceenimage>



		<adword title="全球时尚数据一网打尽" slotheight="557">
			<!-- <div style="height: 597px;"> -->
			<img style="width: 70%;" src="../../static/全球时尚数据一网打尽.gif" />
			<!-- </div> -->
		</adword>



		<adword title="星链C2M数字化平台" slotheight="573">
			<div class="container">
				<div class="flexcenter" style="margin-top: 70px;">

					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/流行趋势分析ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							流行趋势分析
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							基于分布式数据采集技术<br>
							快速掌握当下流行趋势
						</div>
					</div>
					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/趋势预测ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							趋势预测
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							结合海量销售、秀场数据<br>
							预测宏观流行趋势
						</div>
					</div>
					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/个性化推荐ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							个性化推荐
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							根据行业、浏览偏好<br>
							呈现您想要关注的
						</div>
					</div>
					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/店铺数据ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							店铺数据
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							店铺多维度数据追踪<br>
							快速反应调整策略
						</div>
					</div>
				</div>
				<div class="flexcenter" style="margin-top: 70px;">

					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/以图搜图ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							以图搜图
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							亿级高清图像资源<br>
							搜索相似款式
						</div>
					</div>
					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/行业报告ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							行业报告
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							依据权威数据<br>
							每周更新时尚趋势解读
						</div>
					</div>
					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/分类找款ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							分类找款
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							多维度、多组合筛选<br>
							满足各种条件下的搜索呈现
						</div>
					</div>
					<div class="col-md-2">
						<img style="height: 85px; width: 85px;" src="../../static/热点榜单ico.png" />
						<div
							style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
							热点榜单
						</div>
						<div
							style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
							从热销和飙升两大方向<br>
							持续挖掘热点店铺和款式
						</div>
					</div>
				</div>

			</div>
		</adword>



		<div v-if="isShowNavAD" ref="fashionimg1ref">
			<adword style="background-color: #F8F8F8;" title="提升选款决策效率"
				subtitle="星链对海量时尚数据进行有效化分析，为客户的数据企划、智能营销，提供精准、全面、及时的决策支持。" slotheight="427">
				<div>
					<div style="text-align: left;z-index: 0;margin-top: 130px;">
						<img v-if="fashionimg1show" :class="[fashionimg1show ? 'adfadew2' : '']"
							style="margin-left: 30%; width: 40%;height: 17px;" src="../../static/轴承ico3.png">
					</div>

					<div style="z-index: 1;margin-top: -130px;">
						<transition name="adfadex2">
							<img v-if="fashionimg1show" src="../../static/时尚热点ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="fashionimg1show" style="margin-left: 170px;" src="../../static/趋势预测2ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="fashionimg1show" style="margin-left: 170px;" src="../../static/商品企划ico.png" />
						</transition>
					</div>

				</div>
			</adword>
		</div>

		<adword title="竞店追踪" subtitle="基于竞店数据，从品类、属性、品牌维度分析，全面呈现竞店趋势；全方位监控竞店商品；多维度地竞店排行数据。" slotheight="580">
			<div>
				<img class="fashionimage2" src="../../static/竞店追踪.gif" />
			</div>
		</adword>

	</div>
</template>
<script>
import firstsceenimage from '../../components/firstsceenimage.vue'
import Adbigwordbutton from '../../components/adBigWordButton.vue'
import adword from '../../components/adword.vue'
import banner from '../../static/把握流行，精准选款.png'
import img2 from '../../static/脚型报告智能推荐鞋款.png'
import img3 from '../../static/C2M智能定制.png'

// import video from '../../assets/video/2.mp4'

export default {
	name: 'Fashion',
	components: {
		firstsceenimage,
		adword,
		Adbigwordbutton,
		// advideo,
	},
	data() {
		return {
			banner: banner,
			img2: img2,
			img3: img3,

			fashionimg1top: 0,
			fashionimg1show: false,

			isShowNavAD: true,
		}
	},
	mounted() {
		var _this = this
		window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件
		setTimeout(function () {
			_this.fashionimg1top = _this.$refs.fashionimg1ref.offsetTop

			console.log(_this.$refs.fashionimg1ref.offsetTop)
			console.log(_this.$refs)
			console.log("this.fashionimg1top", _this.fashionimg1top)

		}, 200);

		if (window.innerWidth < 1000) {
			this.isShowNavAD = false
		}

		// while (_this.fashionimg1top < 1000) {
		//
		// 	_this.fashionimg1to=1100
		// }




	},
	methods: {

		scrollHandle: function (e) {
			var _this = this
			this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
			//实际高度太晚了，所以要加上一个虚拟高度
			this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop

			if (this.fashionimg1top != 0) {
				if (!this.fashionimg1show) {
					if (this.vscrolltop > this.fashionimg1top) {
						this.fashionimg1show = true;

					}
				}
			}


		},
	},

}
</script>

<style>
@media (max-width: 888px) {

	.fashionimage2 {
		height: 80%;
		width: 80%;
	}

}

@media (min-width: 1000px) {

	.fashionimage2 {
		height: 480px;
		width: 480px;
	}
}


/* 	.adfadew3 {

		animation-name: adfadew3d;
		animation-duration: 0.8s;
	}

	@keyframes adfadew3d {
		0% {
			opacity: 0;
			
		}

		100% {
			opacity: 1;
		 
		}
	} */
</style>
